import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PRE_ACTIVATION_ORGANIZATION_TYPE_OPTIONS } from "../../../utils/constants";
import {
  PRE_ACTIVATION_FIELD_ORGANIZATION_TYPE,
  PRE_ACTIVATION_HINT_ORGANIZATION_TYPE,
} from "../../../i18n/keysTranslations";
import FieldBlock from "../components/FieldBlock";
import FieldError from "../components/FieldError";
import FieldHint from "../components/FieldHint";
import FieldLabel from "../components/FieldLabel";
import SegmentedControl from "../../../components/SegmentedControl/SegmentedControl";

const OrganizationTypeSection = ({
  control,
  readOnly,
  onOrganizationTypeChange,
}) => {
  const { t } = useTranslation();

  const organizationTypeOptions = useMemo(
    () =>
      PRE_ACTIVATION_ORGANIZATION_TYPE_OPTIONS.map((option) => ({
        value: option.value,
        label: t(option.labelKey),
      })),
    [t]
  );

  return (
    <FieldBlock>
      <FieldLabel
        htmlFor="organizationType"
        text={t(PRE_ACTIVATION_FIELD_ORGANIZATION_TYPE)}
        required={!readOnly}
      />
      {!readOnly ? (
        <FieldHint text={t(PRE_ACTIVATION_HINT_ORGANIZATION_TYPE)} />
      ) : null}
      <Controller
        name="organizationType"
        control={control}
        render={({ field, fieldState }) => (
          <>
            <SegmentedControl
              name="organizationType"
              options={organizationTypeOptions}
              selectedValue={field.value}
              onChange={(value) => {
                field.onChange(value);
                onOrganizationTypeChange?.({ organizationType: value });
              }}
              readOnly={readOnly}
            />
            <FieldError message={fieldState.error?.message} />
          </>
        )}
      />
    </FieldBlock>
  );
};

export default OrganizationTypeSection;
